import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=5f514658&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=5f514658&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f514658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f514658')) {
      api.createRecord('5f514658', component.options)
    } else {
      api.reload('5f514658', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=5f514658&scoped=true", function () {
      api.rerender('5f514658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/Layout.vue"
export default component.exports